export default "__VITE_ASSET__c1956f76__"